import { render, staticRenderFns } from "./ReceiptLayout.vue?vue&type=template&id=a195c0f8&scoped=true&"
import script from "./ReceiptLayout.vue?vue&type=script&lang=js&"
export * from "./ReceiptLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a195c0f8",
  null
  
)

export default component.exports